var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Controller } from 'react-hook-form';
import { RadioSelect } from "../../../../../Components/Forms";
import { t, Translate } from "../../../../../../I18N";
import { QuestionMarkCircleIcon } from '@heroicons/react/20/solid';
import { Tooltip } from 'flowbite-react';

export const StyleField = ({ control }) => /*#__PURE__*/
_jsx(Controller, {
  name: "style",
  control: control,
  render: ({ field }) => /*#__PURE__*/
  _jsx(RadioSelect, {
    legend: /*#__PURE__*/_jsx(Translate, {}, void 0, "Style"),
    name: "style",
    options: [
    {
      value: 'cover',
      defaultChecked: field.value === 'cover' || field.value === undefined,
      label: /*#__PURE__*/
      _jsx("span", { className: "flex items-center gap-1" }, "fill", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Fill"), ' ', /*#__PURE__*/
      _jsx(Tooltip
      // eslint-disable-next-line react/style-prop-object
      , { style: "light",
        content: t(
          'System',
          'Will attempt to fill the container, using its entire width. In cards, cropping is likely to occur.',
          null,
          false
        ),
        placement: "right" }, void 0, /*#__PURE__*/

      _jsx(QuestionMarkCircleIcon, { className: "w-5 h-5 text-gray-500" })
      )
      )

    },
    {
      value: 'contain',
      defaultChecked: field.value === 'contain',
      label: /*#__PURE__*/
      _jsx("span", { className: "flex items-center gap-1" }, "fit", /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Fit"), ' ', /*#__PURE__*/
      _jsx(Tooltip
      // eslint-disable-next-line react/style-prop-object
      , { style: "light",
        content: t(
          'System',
          'Will show the entire media inside the container.',
          null,
          false
        ),
        placement: "right" }, void 0, /*#__PURE__*/

      _jsx(QuestionMarkCircleIcon, { className: "w-5 h-5 text-gray-500" })
      )
      )

    }],

    onChange: field.onChange,
    orientation: "horizontal" }
  ) }

);